// extracted by mini-css-extract-plugin
export const pageTitle = "TemplateTitle-module--page-title--3AWMJ";
export const pageTitleOverlay = "TemplateTitle-module--page-title-overlay--2W8LQ";
export const pageTitleContainer = "TemplateTitle-module--page-title-container--zD9cp";
export const pageTitleContent = "TemplateTitle-module--page-title-content--cA_qq";